import { createSelector } from 'reselect'

const getAudienceChart = (state: any) => state.audienceChart

/** A Redux selector to retrieve Audience Chart Data
 * @param state - The Redux state
 * @param {object} - Audience Chart Data.
 */

export const selectAudienceChart = createSelector(
  getAudienceChart,
  (data) => data && data.chartData ? data.chartData : null
)

/** A Redux selector to retrieve Audience Chart Data Loading State
 * @param state - The Redux state
 * @param {boolean} - Boolean value indicating weather audience chart is loading.
 */

export const selectAudienceChartIsLoading = createSelector(
  getAudienceChart,
  (data) => data && data.status.isLoading ? data.status.isLoading : false
)
